import React, { useState, useEffect } from "react";
import { Provider } from "react-redux";
import { Provider as RxDBProvider } from "rxdb-hooks";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
import { Routes } from "../app/Routes";
import { LayoutSplashScreen } from "./context/LayoutContext";
import { I18nProvider } from "./context/i18n";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/Error/ErrorFallback";
import ConfirmationModal from "./components/ConfirmationModal/index.jsx";
import Notification from "./components/Notification/Notification.js";
import PusherProvider from "./context/pusherContext";
import NuanceProvider from "./context/nuanceContext";
import SocketProvider from "./context/socketContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

export default function App({ store, persistor, basename }) {
  //call this endpoint on start of the app https://api.ethizo.com/organization_configurations.json
  //response hsould save in local storage
  const [loadingCompleted, setLoadingCompleted] = useState(false);
  const fetchOrganizationConfig = async () => {
    let organization = window.location.search.split("&organization=")[1];
    if (organization?.length>0) {
      localStorage.setItem("organization_code", organization);
      try {
        const response = await fetch(
          `https://api.ethizo.com/organization_configurations.json`
        );
        const data = await response.json();
        localStorage.setItem(
          "organization_config",
          JSON.stringify(data?.response?.data)
        );
        setLoadingCompleted(true);
      } catch (error) {
        setLoadingCompleted(true);
        console.error("error", error);
      }
    } else {
      setLoadingCompleted(true);
    }
  };
  useEffect(() => {
    fetchOrganizationConfig();
  }, []);
  
  return (
    <>
      {!loadingCompleted ? (
        <LayoutSplashScreen />
      ) : (
        <>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light"
          />
          {/* Error Boundary  */}
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => window.location.reload()}
          >
            {/* Provide Redux store */}
            <Provider store={store}>
              {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
              <PersistGate
                persistor={persistor}
                loading={<LayoutSplashScreen />}
              >
                {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                <React.Suspense fallback={<LayoutSplashScreen />}>
                  {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                  <BrowserRouter basename={basename}>
                    {/* Render routes with provided `Layout`. */}
                    <I18nProvider>
                      <PusherProvider>
                        <SocketProvider>
                          <NuanceProvider>
                            {/* Confirmation Modal */}
                            <ConfirmationModal />
                            {/* Show notification */}
                            <Notification />
                            <AuthInit>
                              <Routes />
                            </AuthInit>
                          </NuanceProvider>
                        </SocketProvider>
                      </PusherProvider>
                    </I18nProvider>
                  </BrowserRouter>
                </React.Suspense>
              </PersistGate>
            </Provider>
          </ErrorBoundary>
        </>
      )}
    </>
  );
}
